import { Update2022VariantSectionContent } from 'productTemplate/components/buyBar/VariantSectionContent/Update2022VariantSectionContent';
import { useWindowSize } from 'shared/hooks/useWindowSize';
import { IProductSearch } from 'shared/types/ProductSearch';

interface IVariantSectionContentProps {
  className?: string;
  variants?: IProductSearch[];
  onClose?: () => void;
  sectionTitle?: string;
}

export const VariantSectionContent = ({
  className,
  variants,
  sectionTitle,
  onClose,
}: IVariantSectionContentProps) => {
  const { isMobile } = useWindowSize();

  return isMobile ? (
    <Update2022VariantSectionContent
      className={className}
      title={sectionTitle}
      variants={variants}
      onClose={onClose}
    />
  ) : (
    <Update2022VariantSectionContent className={className} variants={variants} />
  );
};
